module.exports = __webpack_public_path__ + "media/images/common/qr_sp-4fa2a51d3f7f6b49ae8f5cd6a78a022f.gif";